export default (theme) => {
  return {
    container: ({ padding }) => {
      return {
        padding: theme.spacing(padding),
      }
    },
  }
}
